import styled from "styled-components";

export const V3AWrapper = styled.div`
    padding: 20px;
    background: ${({ theme }) => theme ? theme.v3.colors.grey96 : null};
    border-radius: 6px;
`;

export const V3ACustomControls = styled.div<{ $show: boolean }>`
    display:  ${({ $show }) => $show ? 'flex' : 'none'};
    align-items: center;

    > div {
        display: inline-flex;
        margin-right: 12px;

        &:nth-child(2) {
            flex: 1;
        }

        svg {
            &:hover {
                cursor: pointer;
            }
        }
    }
`;

export const V3Audio = styled.div<{ $show: boolean }>`
    width:  ${({ $show }) => $show ? 'auto' : '0'};
    overflow:  ${({ $show }) => $show ? 'auto' : 'hidden'};
`;